import { ArrowUpRight } from "lucide-react";
import { support, SUPPORT_URL } from "@/content/copy";
import { scrollToId } from "@/lib/scroll";
import { Eyebrow, Reveal } from "./primitives";

export const Support = () => (
  <section id="support" data-testid="support-section" aria-labelledby="support-heading" className="pb-20 sm:pb-28 scroll-mt-20">
    <div className="ph-container">
      <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 border-t ph-rule pt-14 sm:pt-20">
        <Reveal className="lg:col-span-5">
          <Eyebrow>{support.eyebrow}</Eyebrow>
          <h2 id="support-heading" data-testid="support-heading" className="ph-h3 mt-5">{support.heading}</h2>
        </Reveal>
        <Reveal delay={0.08} className="lg:col-span-6 lg:col-start-7">
          <p data-testid="support-body" className="ph-body">{support.body}</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" data-testid="support-btn" className="ph-btn ph-btn-solid">
              <span>{support.button}</span>
              <span className="ph-btn-icon" aria-hidden="true"><ArrowUpRight size={18} strokeWidth={2.2} /></span>
              <span className="sr-only"> (opens secure Stripe checkout in a new tab)</span>
            </a>
            <a href="#goal" onClick={(e) => { e.preventDefault(); scrollToId("#goal"); }} data-testid="support-btn-mission" className="ph-btn ph-btn-ghost">
              <span>{support.secondary}</span>
            </a>
          </div>
          <p data-testid="support-note" className="ph-note mt-6 text-sm">
            <span className="ph-note-mark" aria-hidden="true">*</span>{support.note}
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
